import Roles from "../../enum/Role";

export const SelectRole = (role) => {
  switch (role) {
    case Roles.Admin:
      return "admin";

    case Roles.EstateAdmin:
      return "estate_admin";
    case Roles.EstateManager:
      return "estate_manager";

    case Roles.TribeAdmin:
      return "tribe_admin";

    case Roles.TribeManager:
      return "tribe_manager";
    
    case Roles.ClusterAdmin:
      return "cluster_admin";

    case Roles.ClusterManager:
      return "cluster_manager";
    default:
      return;
  }
};

export const SelectActiveRole = (roles) => {
  const activeRole = roles.includes(Roles.ClusterManager)
    ? Roles.ClusterManager
    : roles.includes(Roles.ClusterAdmin)
    ? Roles.ClusterAdmin
    : roles.includes(Roles.EstateManager)
    ? Roles.EstateManager
    : roles.includes(Roles.EstateAdmin)
    ? Roles.EstateAdmin
    : roles.includes(Roles.TribeManager)
    ? Roles.TribeManager
    : roles.includes(Roles.TribeAdmin)
    ? Roles.TribeAdmin
    : roles.includes(Roles.Admin)
    ? Roles.Admin
    : null;

  return activeRole;
};
